import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MainLayoutComponent } from './main.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarModule } from 'ng-sidebar';
import { DetectionDetailModule } from '../../features/detection/pages/detection-page/components/detection-detail/detection-detail.module';

@NgModule({
  declarations: [MainLayoutComponent, HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    NgbTooltipModule,
    RouterModule,
    SidebarModule,
    DetectionDetailModule,
  ],
  exports: [MainLayoutComponent],
})
export class MainLayoutModule {}
